import { useState, useEffect } from "react";
import { useDeviceDetection } from "./useDeviceDetection";

export const useAppDownloadModal = () => {
  const [showModal, setShowModal] = useState(false);
  const deviceInfo = useDeviceDetection();

  useEffect(() => {
    // Aguardar um pouco para garantir que a página carregou completamente
    const timer = setTimeout(() => {
      checkShouldShowModal();
    }, 2000); // 2 segundos após o carregamento

    return () => clearTimeout(timer);
  }, [deviceInfo]);

  const checkShouldShowModal = () => {
    // Verificar se já foi mostrado e o usuário escolheu não mostrar novamente
    const dismissed = localStorage.getItem("@app-download-modal-dismissed");
    if (dismissed === "true") return;

    // Verificar se já foi mostrado hoje
    const shown = localStorage.getItem("@app-download-modal-shown");
    const today = new Date().toDateString();
    const shownDate = localStorage.getItem("@app-download-modal-date");

    if (shown === "true" && shownDate === today) return;

    // Verificar se está no período de "lembrar depois"
    const remindDate = localStorage.getItem("@app-download-remind-date");
    if (remindDate) {
      const remind = new Date(remindDate);
      const now = new Date();
      if (now < remind) return;
    }

    // CONDIÇÃO PRINCIPAL: Mostrar apenas para dispositivos móveis acessando via navegador web
    if (
      deviceInfo.isMobile &&
      deviceInfo.isWebBrowser &&
      !deviceInfo.isStandalone
    ) {
      setShowModal(true);
      // Marcar a data que foi mostrado
      localStorage.setItem("@app-download-modal-date", today);
    }
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return {
    showModal,
    closeModal,
  };
};
